const showroomBody = document.body;

if (showroomBody?.dataset.showroomMode === 'true') {
  const contactUrl = showroomBody.dataset.showroomContactUrl || '/pages/contact';

  document.addEventListener(
    'submit',
    (event) => {
      const form = event.target;
      if (!(form instanceof HTMLFormElement)) return;

      const action = new URL(form.action || window.location.href, window.location.origin);
      const isCartAction = action.pathname.includes('/cart/add') || action.pathname.includes('/checkout');
      const isCheckoutAction = event.submitter instanceof HTMLElement && event.submitter.matches('[name="checkout"]');

      if (!isCartAction && !isCheckoutAction) return;

      event.preventDefault();
      event.stopImmediatePropagation();
      window.location.assign(contactUrl);
    },
    true
  );

  document.addEventListener(
    'click',
    (event) => {
      if (!(event.target instanceof Element)) return;
      const cartLink = event.target.closest('a[href="/cart"], a[href^="/cart?"], a[href$="/cart"]');
      if (!cartLink) return;

      event.preventDefault();
      window.location.assign(contactUrl);
    },
    true
  );
}
